import { render, staticRenderFns } from "./ManageCalibrationPatternTemplateParameter.vue?vue&type=template&id=60a85488&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageCalibrationPatternTemplateParameter.vue?vue&type=style&index=0&id=60a85488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a85488",
  null
  
)

export default component.exports